<template>
    <div id="contenedor-administracion-contrato-estado-de-cuenta">
        <v-card>
            <v-card-title>
                Estado de Cuenta
                <v-spacer></v-spacer>
                <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
                </v-btn>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-card-text>
                <v-container >
                <v-row >
                <v-col>
            <v-toolbar-title
                class="display-1">
                {{ contrato.numero }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
                <date-picker
                    v-model="fechaAlDeEstadoDeCuenta"
                    label="Fecha"

                    dense>
                </date-picker>

                <v-divider class="bkground" />
                <v-card-actions >
                    <v-spacer></v-spacer>
                    <custom-button
                        @click="cerrar"
                        tipo="formCancelar"
                        label="Cerrar"
                        class="mr-3">
                    </custom-button>
                    <custom-button
                        @click="generarEstadoDeCuenta"
                        tipo="formAceptar"
                        label="Generar"
                        :loading="generandoEstadoCuenta"
                        >
                    </custom-button>
                </v-card-actions>
                </v-col>
                </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>

import DatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';
import mixEstadoCuenta from '@/components/administracion/contratos/contrato/reportes/estadodecuenta/mixEstadoCuenta';

export default {
  name: 'AdministracionContratoEstadoDeCuenta',
  components: {
    CustomButton,
    DatePicker,
  },
  mixins: [
    mixGenerarPdf, mixFormatoEstructura, mixEstadoCuenta,
  ],
  props: {

  },
  data() {
    return {
      fechaAlDeEstadoDeCuenta: '',
      generandoEstadoCuenta: false,

    };
  },
  mounted() {
    const hoy = new Date().toLocaleDateString('en-US');
    this.fechaAlDeEstadoDeCuenta = new Date(hoy).toISOString().substr(0, 10);
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarEstadoDeCuenta() {
      this.generandoEstadoCuenta = true;
      const nombreTemplate = 'templateEstadoCuenta';
      const fotos = this.getContratoFotos;

      const datosModificados = this.getDatosModificados;

      const importeContrato = this.importeDelContrato;

      const importeEjercidoSinIva = this.$numberRound(this.$ObjSumar(this.getContratoEstimaciones, 'importeEstimado')
      + this.$ObjSumar(this.getContratoEscalatorias, 'importe')
      + this.$ObjSumar(this.getContratoGastos, 'importe'));

      let importePorEjercerSinIva = this.$numberRound(importeContrato - importeEjercidoSinIva);
      if (Number.isNaN(importePorEjercerSinIva)) importePorEjercerSinIva = 0;

      const importeAnticipoPorAmortizar = this.$numberRound(this.$ObjSumar(this.getContratoAnticipos, 'importeInicioTrabajos')
      - this.$ObjSumar(this.getContratoEstimaciones, 'importeAmortizacionAnticipo'));

      const estimacionesConPagos = this.getContratoEstimaciones
        .map((e) => ({ ...e, pagado: this.getPagosElemento(e.id, this.fechaAlDeEstadoDeCuenta) }));
      const estimacionesPagado = estimacionesConPagos.map((p) => ({ pagado: p.pagado.total }));

      const escalatoriasConPagos = this.getContratoEscalatorias
        .map((e) => ({ ...e, pagado: this.getPagosElemento(e.id, this.fechaAlDeEstadoDeCuenta) }));
      const escalatoriasPagado = escalatoriasConPagos.map((p) => ({ pagado: p.pagado.total }));

      const gastosConPagos = this.getContratoGastos
        .map((g) => ({ ...g, pagado: this.getPagosElemento(g.id, this.fechaAlDeEstadoDeCuenta) }));
      const gastosPagado = gastosConPagos.map((p) => ({ pagado: p.pagado.total }));

      const anticiposConPagos = this.getContratoAnticipos
        .map((a) => ({ ...a, pagado: this.getPagosElemento(a.id, this.fechaAlDeEstadoDeCuenta) }));
      const anticiposPagado = anticiposConPagos.map((p) => ({ pagado: p.pagado.total }));

      const totalEstimaciones = {
        importeCostoDirecto: this.$ObjSumar(this.getContratoEstimaciones, 'importeCostoDirecto'),
        importeCostoIndirectos: this.$ObjSumar(this.getContratoEstimaciones, 'importeCostoIndirectos'),
        importeUtilidad: this.$ObjSumar(this.getContratoEstimaciones, 'importeUtilidad'),
        importeCargosAdicionales: this.$ObjSumar(this.getContratoEstimaciones, 'importeCargosAdicionales'),
        importeEstimado: this.$ObjSumar(this.getContratoEstimaciones, 'importeEstimado'),
        importeAmortizacionAnticipo: this.$ObjSumar(this.getContratoEstimaciones, 'importeAmortizacionAnticipo'),
        subtotal: this.$ObjSumar(this.getContratoEstimaciones, 'subtotal'),
        importeCostoFinanciero: this.$ObjSumar(this.getContratoEstimaciones, 'importeCostoFinanciero'),
        subtotalDos: this.$ObjSumar(this.getContratoEstimaciones, 'subtotalDos'),
        importeIva: this.$ObjSumar(this.getContratoEstimaciones, 'importeIva'),
        totalFactura: this.$ObjSumar(this.getContratoEstimaciones, 'totalFactura'),
        importeDeducciones: this.$ObjSumar(this.getContratoEstimaciones, 'importeDeducciones'),
        importeRetenido: this.$ObjSumar(this.getContratoEstimaciones, 'importeRetenido'),
        importeDevuelto: this.$ObjSumar(this.getContratoEstimaciones, 'importeDevuelto'),
        importeSancion: this.$ObjSumar(this.getContratoEstimaciones, 'importeSancion'),
        importeBonificacion: this.$ObjSumar(this.getContratoEstimaciones, 'importeBonificacion'),
        importeLiquido: this.$ObjSumar(this.getContratoEstimaciones, 'importeLiquido'),
        importePagado: this.$ObjSumar(estimacionesPagado, 'pagado'),
      };
      const generalesDos = {
        avanceFinanciero: this.getAvanceFinancieroGenerales,
        avanceProgramado: this.getAvanceProgramadoGenerales,
        avanceFisico: this.getAvanceFisicoGenerales,
        tieneObras: this.getContrato.obras.length ? this.getContrato.obras.length : 0,
        tieneAnticipos: this.getContratoAnticipos.length ? this.getContratoAnticipos.length : 0,
        tieneConvenios: this.getContratoConvenios.length ? this.getContratoConvenios.length : 0,
        tieneFianzas: this.getContratoFianzas.length ? this.getContratoFianzas.length : 0,
        tieneEstimaciones: this.getContratoEstimaciones.length
          ? this.getContratoEstimaciones.length : 0,
        tieneEscalatorias: this.getContratoEscalatorias.length
          ? this.getContratoEscalatorias.length : 0,
        tieneGastos: this.getContratoGastos.length ? this.getContratoGastos.length : 0,
        tieneFotos: fotos.length ? fotos.length : 0,
        tieneGrafica: this.getDataGrafica.programado.length
          ? this.getDataGrafica.programado.length : 0,
      };

      const generales = {
        sumaImporteAnticipos: this.$ObjSumar(this.getContratoAnticipos, 'importe'),
        sumaIvaAnticipos: this.$ObjSumar(this.getContratoAnticipos, 'iva'),
        sumaTotalAnticipos: this.$ObjSumar(this.getContratoAnticipos, 'total'),
        sumaPagadoAnticipos: this.$ObjSumar(anticiposPagado, 'pagado'),
        sumaImporteInicioTrabajos: this.$ObjSumar(this.getContratoAnticipos, 'importeInicioTrabajos'),
        sumaImporteCostoFinanciamiento: this.$ObjSumar(this.getContratoAnticipos, 'importeCostoFinanciamiento'),
        sumaTotalEscalatorias: this.$ObjSumar(this.getContratoEscalatorias, 'total'),
        sumaImporteEscalatorias: this.$ObjSumar(this.getContratoEscalatorias, 'importe'),
        sumaIvaEscalatorias: this.$ObjSumar(this.getContratoEscalatorias, 'iva'),
        sumaPagadoEscalatorias: this.$ObjSumar(escalatoriasPagado, 'pagado'),
        sumaTotalGastos: this.$ObjSumar(this.getContratoGastos, 'total'),
        sumaImporteGastos: this.$ObjSumar(this.getContratoGastos, 'importe'),
        sumaIvaGastos: this.$ObjSumar(this.getContratoGastos, 'iva'),
        sumaPagadoGastos: this.$ObjSumar(gastosPagado, 'pagado'),
        datosModificados,
        importePorEjercerSinIva,
        importeEjercidoSinIva,
        importeAnticipoPorAmortizar,
        importeContrato,

      };

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
            footerTemplate: '',
          },
          nombreTemplate,
        },
        data: {
          contrato: this.formatoObjeto(this.getContrato),
          anticipos: this.formatoObjeto(anticiposConPagos),
          convenios: this.formatoObjeto(this.getContratoConvenios),
          fianzas: this.formatoObjeto(this.getContratoFianzas),
          escalatorias: this.formatoObjeto(escalatoriasConPagos),
          gastos: this.formatoObjeto(gastosConPagos),
          estimaciones: this.formatoObjeto(estimacionesConPagos),
          grafica: this.getDataGrafica,
          fotos,
          totalEstimaciones: this.formatoObjeto(totalEstimaciones),
          generales: this.formatoObjeto(generales),
          generalesDos: this.formatoObjeto(generalesDos),
          fecha: this.formatoObjeto({ fecha: this.fechaAlDeEstadoDeCuenta }),
          footer: '',
        },
      }, `${this.contrato.numero}_EstadoCuenta`);
      this.generandoEstadoCuenta = false;
    },
    cerrar() {
      this.$emit('cerrarGenerarEstadoCuenta');
    },
  },

};

</script>

<style lang="scss" scoped>

</style>
